export const KPI_LABEL_DEFS = [
  { key: "total_valor", label: "Faturação Total" },
  { key: "total_custos", label: "Custos Totais" },
  { key: "total_custos_indiretos", label: "Custos Indiretos" },
  { key: "total_margem", label: "Margem Total" },
  { key: "total_lucro_mundideias", label: "Lucro Mundideias" },
  { key: "total_mundideias", label: "Mundideias + Custos Ind." },
  { key: "avg_margin_pct", label: "Margem Média" },
  { key: "resultado_liquido", label: "Mund.+C.Ind. − Equipa" },
  { key: "total_equipa", label: "Total Equipa" },
];

export const KPI_DEFAULT_LABELS = Object.fromEntries(
  KPI_LABEL_DEFS.map((d) => [d.key, d.label])
);

export function resolveKpiLabel(labels, key) {
  const custom = labels?.[key];
  return custom && custom.trim() ? custom : KPI_DEFAULT_LABELS[key];
}
